/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


/**
 * Returns syntax-highlighting rules for PowerMTA configuration.
 * @see https://ace.c9.io/#nav=higlighter&api=virtual_renderer
 *
 * @return
 *      syntax-highlighting rules.
 */
export function getRules() {
    return {
        "start": [
            {
                token: "comment",
                regex: /#.*$/
            },
            {
                token: "string",
                regex: /".*?"|'.*?'/
            },
            // @release 5.0 Currently we show only section beginning and ending
            // lines in different style (as keywords).  Ideally we would put in
            // the list of all "valid" directive and section names here.  We do
            // not have a way to automatically fetch such a list from the code
            // base.  If we manually put in the list we run into the risk of
            // being out of sync with the code.  Should we do that anyway for
            // now, until we have an automated way to fetch the list?
            // @see https://trac.int.port25.com/ticket/1937
            {
                token: "keyword",
                regex: /<.*>/
            },
            {
                caseInsensitive: true
            }
        ]
    }
}
